import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';

import React, { Component } from 'react'
// import { Link } from 'react-router-dom'

import ObjPushCardFormation from './ObjPushCardFormation'
import Slider from "react-slick"

import { throttle, isMobile, equalHeight } from "../../utilities/FrontFunctions/AoxGlobalFrontFunctions"

import '../../assets/css/0020_objects/0670_obj_mon_parcours_formation.css'

class ObjMonParcoursFormation extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isMobile: isMobile()
		}
		this.handleWindowResizeMainHeader = this.handleWindowResizeMainHeader.bind(this)
		this.throttleWindowResizeMainHeader = throttle(this.handleWindowResizeMainHeader, 200)
		this.handleButtonFav = this.props.handleButtonFav.bind(this)
	}
	handleWindowResizeMainHeader() {
		this.setState({
			isMobile: isMobile()
		})
		this.applyEqualHeight()
	}

	componentDidMount() {
		this.applyEqualHeight()
		window.addEventListener('resize', this.throttleWindowResizeMainHeader)
	}
	componentWillUnmount() {
		window.removeEventListener('resize', this.throttleWindowResizeMainHeader)
	}
	applyEqualHeight() {
		setTimeout(() => {
			equalHeight(".obj_mon_parcours_formation .obj_push_card .ctn_text_card");
		});
	}
    
    onSwipe() {
        if (this.slider) {
          	this.slider.innerSlider.clickable = true;
        }
	}
    
	render() {
        const { datasParcour } = this.props;

		const sliderRef = slider => {this.slider = slider}
        const settings = {
            className: "obj_carousel_formation obj_carrousel_slider",
            centerMode: true,
			infinite: false,
			slidesToShow: 1,
			swipeToSlide: true,
			onSwipe: this.onSwipe.bind(this),
            // variableWidth: true,
			centerPadding: "10%",
            dots: true,
            dotsClass: "slider-nav",
            appendDots: dots => (
                <div className="slider-nav" >
                    <ul> {dots} </ul>
                </div>
            ),
            arrows: false,
            speed: 750,
        }

		return (<>{datasParcour && <>
			<div className="obj_mon_parcours_formation">
				<div className="ctn_title">
					<h3 className="t_title">{datasParcour.Parcours_Title}</h3>
					<p className="t_desc">{datasParcour.Formations.length} {datasParcour.Formations.length > 1 ?  "formations" : "formation"}</p>
				</div>
				
				{ this.state.isMobile &&

					<div className="ctn_carrousel">
						<Slider {...settings} ref={sliderRef}>
                            {datasParcour.Formations.map((datasTraining, index) => (
                                <div className="item" key={index} >
                                    <ObjPushCardFormation typeofPush="Formation" datasTraining={datasTraining} handleButtonFav={this.props.handleButtonFav}/>
                                </div>
                            ))}
						</Slider>
					</div>

					}

				{!this.state.isMobile &&

					<div className="ctn_row">
                        {datasParcour.Formations.map((datasTraining, index) => (
                            <ObjPushCardFormation key={index} typeofPush="Formation" datasTraining={datasTraining} handleButtonFav={this.props.handleButtonFav}/>
                        ))}
					</div>

				}
				
			</div>
		</>}</>)
	}

}

export default withTranslation()(withSitecoreContext()(ObjMonParcoursFormation));